__turbopack_context__.v({
  "backButton": "styles-module-scss-module__pmr6La__backButton",
  "close": "styles-module-scss-module__pmr6La__close",
  "closeButton": "styles-module-scss-module__pmr6La__closeButton",
  "root": "styles-module-scss-module__pmr6La__root",
  "title": "styles-module-scss-module__pmr6La__title",
  "titleIcon": "styles-module-scss-module__pmr6La__titleIcon",
});
